import { request } from '@/utils/request'
import { getBaseUrlStore, getParameter } from '@/utils/endpoint'

export function getOutlet(id, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.get(getBaseUrlStore() + '/outlet/' + id, {
    globalParamUrlId: false,
    params: new_params
  })
}

export function listOutlet(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.get(getBaseUrlStore() + '/outlet', {
    globalParamUrlId: false,
    params: new_params
  })
}
